import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  doc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import Swal from "sweetalert2";

export default function ManagePengumumanAgenda() {
  const [items, setItems] = useState([]);
  const ref = collection(db, "pengumumanAgenda");

  const fetchItems = async () => {
    const snap = await getDocs(ref);
    const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    data.sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
    setItems(data);
  };

  useEffect(() => {
    fetchItems();
  }, []);

  // ================= ADD / EDIT MODAL =================
  const openFormModal = async (item = null) => {
    const isEdit = !!item;

    const { value: form } = await Swal.fire({
      title: isEdit ? "Edit Pengumuman / Agenda" : "Tambah Pengumuman / Agenda",
      width: "700px",
      html: `
        <div style="text-align:left; max-height:65vh; overflow-y:auto;">
          <style>
            label { font-weight:600; margin-top:10px; display:block; }
            .swal2-input, .swal2-textarea, .swal2-select {
              width:100% !important;
              margin:6px 0 12px 0;
            }
          </style>

          <label>Tipe</label>
          <select id="type" class="swal2-select">
            <option value="pengumuman">Pengumuman</option>
            <option value="agenda">Agenda</option>
          </select>

          <label>Judul</label>
          <input id="judul" class="swal2-input" value="${item?.judul || ""}">

          <label>Tanggal</label>
          <input id="tanggal" type="date" class="swal2-input" value="${item?.tanggal || ""}">

          <div id="field-pengumuman">
            <label>Deskripsi</label>
            <textarea id="deskripsi" class="swal2-textarea">${item?.deskripsi || ""}</textarea>
          </div>

          <div id="field-agenda">
            <label>Lokasi / Keterangan</label>
            <input id="lokasi" class="swal2-input" value="${item?.lokasi || ""}">
          </div>
        </div>
      `,
      didOpen: () => {
        const typeSelect = document.getElementById("type");
        typeSelect.value = item?.type || "pengumuman";

        const toggleField = () => {
          document.getElementById("field-pengumuman").style.display =
            typeSelect.value === "pengumuman" ? "block" : "none";
          document.getElementById("field-agenda").style.display =
            typeSelect.value === "agenda" ? "block" : "none";
        };

        toggleField();
        typeSelect.addEventListener("change", toggleField);
      },
      showCancelButton: true,
      confirmButtonText: isEdit ? "Update" : "Simpan",
      cancelButtonText: "Batal",
      preConfirm: () => {
        const type = document.getElementById("type").value;
        const judul = document.getElementById("judul").value;
        const tanggal = document.getElementById("tanggal").value;
        const deskripsi = document.getElementById("deskripsi").value;
        const lokasi = document.getElementById("lokasi").value;

        if (!judul || !tanggal) {
          Swal.showValidationMessage("Judul dan tanggal wajib diisi");
          return false;
        }

        if (type === "pengumuman" && !deskripsi) {
          Swal.showValidationMessage("Deskripsi pengumuman wajib diisi");
          return false;
        }

        return {
          type,
          judul,
          tanggal,
          deskripsi: type === "pengumuman" ? deskripsi : "",
          lokasi: type === "agenda" ? lokasi : "",
        };
      },
    });

    if (!form) return;

    try {
      Swal.fire({
        title: "Menyimpan...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      if (isEdit) {
        await updateDoc(doc(db, "pengumumanAgenda", item.id), form);
        Swal.fire("Berhasil!", "Data berhasil diperbarui", "success");
      } else {
        await addDoc(ref, form);
        Swal.fire("Berhasil!", "Data berhasil ditambahkan", "success");
      }

      fetchItems();
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Gagal menyimpan data", "error");
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Yakin hapus data ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
      cancelButtonText: "Batal",
    });
    if (!confirm.isConfirmed) return;

    await deleteDoc(doc(db, "pengumumanAgenda", id));
    Swal.fire("Terhapus!", "Data berhasil dihapus", "success");
    fetchItems();
  };

  // ================= RENDER =================
  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Kelola Pengumuman & Agenda</h3>
        <button className="btn btn-primary" onClick={() => openFormModal()}>
          + Tambah Data
        </button>
      </div>

      <ul className="list-group">
        {items.length === 0 ? (
          <li className="list-group-item">Belum ada data</li>
        ) : (
          items.map((i) => (
            <li
              key={i.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{i.judul}</strong>{" "}
                <small className="text-muted">
                  ({i.type}) – {new Date(i.tanggal).toLocaleDateString()}
                </small>
              </div>
              <div>
                <button
                  className="btn btn-warning btn-sm me-1"
                  onClick={() => openFormModal(i)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(i.id)}
                >
                  Hapus
                </button>
              </div>
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
